module.exports = __webpack_public_path__ + "img/carrousel-video-6.40aea425.png";